module.exports = __webpack_public_path__ + "static/media/partitionSubImg2.77af8f77.png";